/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import MarketGoogleStoreProductInfoRequest from '../model/MarketGoogleStoreProductInfoRequest';
import MarketGoogleStoreProductInfoResponse from '../model/MarketGoogleStoreProductInfoResponse';
import MarketGoogleStoreProductListRequest from '../model/MarketGoogleStoreProductListRequest';
import MarketGoogleStoreProductListResponse from '../model/MarketGoogleStoreProductListResponse';
import MarketGoogleStoreProductSortUpdateRequest from '../model/MarketGoogleStoreProductSortUpdateRequest';
import MarketGoogleStoreProductUpsertRequest from '../model/MarketGoogleStoreProductUpsertRequest';
import MarketItemShopInfoRequest from '../model/MarketItemShopInfoRequest';
import MarketItemShopInfoResponse from '../model/MarketItemShopInfoResponse';
import MarketItemShopListRequest from '../model/MarketItemShopListRequest';
import MarketItemShopListResponse from '../model/MarketItemShopListResponse';
import MarketItemShopSortUpdateRequest from '../model/MarketItemShopSortUpdateRequest';
import MarketItemShopUpsertRequest from '../model/MarketItemShopUpsertRequest';

/**
* PerplayMarket service.
* @module api/PerplayMarketApi
* @version 1.0
*/
export default class PerplayMarketApi {

    /**
    * Constructs a new PerplayMarketApi. 
    * @alias module:api/PerplayMarketApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayMarketGoogleStoreProductInfoPost operation.
     * @callback module:api/PerplayMarketApi~apiPerplayMarketGoogleStoreProductInfoPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MarketGoogleStoreProductInfoResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MarketGoogleStoreProductInfoRequest} [marketGoogleStoreProductInfoRequest] 
     * @param {module:api/PerplayMarketApi~apiPerplayMarketGoogleStoreProductInfoPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MarketGoogleStoreProductInfoResponse}
     */
    apiPerplayMarketGoogleStoreProductInfoPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['marketGoogleStoreProductInfoRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MarketGoogleStoreProductInfoResponse;
      return this.apiClient.callApi(
        '/api/PerplayMarket/GoogleStoreProductInfo', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMarketGoogleStoreProductListPost operation.
     * @callback module:api/PerplayMarketApi~apiPerplayMarketGoogleStoreProductListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MarketGoogleStoreProductListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MarketGoogleStoreProductListRequest} [marketGoogleStoreProductListRequest] 
     * @param {module:api/PerplayMarketApi~apiPerplayMarketGoogleStoreProductListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MarketGoogleStoreProductListResponse}
     */
    apiPerplayMarketGoogleStoreProductListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['marketGoogleStoreProductListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MarketGoogleStoreProductListResponse;
      return this.apiClient.callApi(
        '/api/PerplayMarket/GoogleStoreProductList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMarketGoogleStoreProductSortUpdatePost operation.
     * @callback module:api/PerplayMarketApi~apiPerplayMarketGoogleStoreProductSortUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MarketGoogleStoreProductSortUpdateRequest} [marketGoogleStoreProductSortUpdateRequest] 
     * @param {module:api/PerplayMarketApi~apiPerplayMarketGoogleStoreProductSortUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayMarketGoogleStoreProductSortUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['marketGoogleStoreProductSortUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayMarket/GoogleStoreProductSortUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMarketGoogleStoreProductUpsertPost operation.
     * @callback module:api/PerplayMarketApi~apiPerplayMarketGoogleStoreProductUpsertPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MarketGoogleStoreProductUpsertRequest} [marketGoogleStoreProductUpsertRequest] 
     * @param {module:api/PerplayMarketApi~apiPerplayMarketGoogleStoreProductUpsertPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayMarketGoogleStoreProductUpsertPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['marketGoogleStoreProductUpsertRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayMarket/GoogleStoreProductUpsert', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMarketItemShopInfoPost operation.
     * @callback module:api/PerplayMarketApi~apiPerplayMarketItemShopInfoPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MarketItemShopInfoResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MarketItemShopInfoRequest} [marketItemShopInfoRequest] 
     * @param {module:api/PerplayMarketApi~apiPerplayMarketItemShopInfoPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MarketItemShopInfoResponse}
     */
    apiPerplayMarketItemShopInfoPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['marketItemShopInfoRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MarketItemShopInfoResponse;
      return this.apiClient.callApi(
        '/api/PerplayMarket/ItemShopInfo', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMarketItemShopListPost operation.
     * @callback module:api/PerplayMarketApi~apiPerplayMarketItemShopListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MarketItemShopListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MarketItemShopListRequest} [marketItemShopListRequest] 
     * @param {module:api/PerplayMarketApi~apiPerplayMarketItemShopListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MarketItemShopListResponse}
     */
    apiPerplayMarketItemShopListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['marketItemShopListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MarketItemShopListResponse;
      return this.apiClient.callApi(
        '/api/PerplayMarket/ItemShopList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMarketItemShopSortUpdatePost operation.
     * @callback module:api/PerplayMarketApi~apiPerplayMarketItemShopSortUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MarketItemShopSortUpdateRequest} [marketItemShopSortUpdateRequest] 
     * @param {module:api/PerplayMarketApi~apiPerplayMarketItemShopSortUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayMarketItemShopSortUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['marketItemShopSortUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayMarket/ItemShopSortUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMarketItemShopUpsertPost operation.
     * @callback module:api/PerplayMarketApi~apiPerplayMarketItemShopUpsertPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MarketItemShopUpsertRequest} [marketItemShopUpsertRequest] 
     * @param {module:api/PerplayMarketApi~apiPerplayMarketItemShopUpsertPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayMarketItemShopUpsertPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['marketItemShopUpsertRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayMarket/ItemShopUpsert', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMarketMarketNftCancelListingNoGet operation.
     * @callback module:api/PerplayMarketApi~apiPerplayMarketMarketNftCancelListingNoGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} listingNo 
     * @param {module:api/PerplayMarketApi~apiPerplayMarketMarketNftCancelListingNoGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayMarketMarketNftCancelListingNoGet(listingNo, callback) {
      let postBody = null;
      // verify the required parameter 'listingNo' is set
      if (listingNo === undefined || listingNo === null) {
        throw new Error("Missing the required parameter 'listingNo' when calling apiPerplayMarketMarketNftCancelListingNoGet");
      }

      let pathParams = {
        'listingNo': listingNo
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayMarket/MarketNftCancel/{listingNo}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
